var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiterepeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:none;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st2{display:inline;fill:#FFFFFF;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st3{display:inline;}\r\n\t.st4{fill:#FFFFFF;stroke:#FEC053;stroke-miterlimit:10;}\r\n\t.st5{fill:#FEC053;}\r\n\t.st6{display:inline;fill:none;stroke:#D9D8D6;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#D9D8D6;stroke-miterlimit:10;}\r\n\t.st8{fill:#D9D8D6;}\r\n\t.st9{display:inline;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st12{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.2,15.3 11.9,10.1 11.5,19.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.2,15.3 10.9,10.7 10.6,19.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 9.5,
    className: "st2",
    width: 0.3,
    height: 11.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.5,
    className: "st4",
    width: 0.3,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 9.5,
    className: "st4",
    width: 0.3,
    height: 11.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.8,14.7 19.1,19.3 19.4,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 9.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 21.4583 30)",
    className: "st1",
    width: 0.3,
    height: 11.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,16.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.7,1.4-1.8,2.2-3.3,2.5c-0.2,0-0.4,0-0.6,0c-2.9,0-5.8,0-8.7,0 c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.1c0.4,0.4,0.9,0.9,1.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.1-0.5-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.6-0.6-1.2-1.2-1.9-1.9c-0.3-0.3-0.3-0.5,0-0.8c0.7-0.7,1.5-1.5,2.2-2.2 c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.4-0.8,0.8-1.3,1.3 c0,0-0.1,0.1-0.1,0.1c0,0,0.1,0,0.1,0c2.9,0,5.9,0,8.8,0c1.6,0,2.8-1,3.2-2.6c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6,0-1.1,0-1.7 c0-0.3,0.1-0.5,0.3-0.5c0.2-0.1,0.4,0,0.6,0.3C22.4,14.7,22.4,15.6,22.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,10.5c0,0.1-0.1,0.2-0.2,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0-0.4-0.1-0.5-0.3 c-0.1-0.2-0.1-0.4,0.1-0.6c0.4-0.4,0.9-0.9,1.3-1.3c0,0,0.1-0.1,0.1-0.1c0,0-0.1,0-0.1,0c-2.9,0-5.8,0-8.7,0c-1.6,0-2.9,1-3.2,2.6 c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.6,0,1.2,0,1.7c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.6,0-1.3,0-1.9c0-1,0.4-1.9,1-2.6 c0.7-0.8,1.7-1.3,2.8-1.4c0.2,0,0.3,0,0.5,0c2.9,0,5.8,0,8.7,0c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.4-0.9-0.9-1.3-1.3 c-0.3-0.3-0.3-0.7,0.1-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.7,0.7,1.4,1.4,2.2,2.2c0.1,0.1,0.1,0.2,0.2,0.3 C22.4,10.3,22.4,10.4,22.4,10.5z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 19.8,
    y1: 10.2,
    x2: 10.2,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.2,10.2c9.5,9.5,9.5,9.5,9.5,9.5"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "20.2,15.3 11.9,10.1 11.5,19.9  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "18.2,15.3 10.9,10.7 10.6,19.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 9.5,
    className: "st6",
    width: 0.3,
    height: 11.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.5,
    className: "st7",
    width: 0.3,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 9.5,
    className: "st7",
    width: 0.3,
    height: 11.1
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "11.8,14.7 19.1,19.3 19.4,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 9.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 21.4583 30)",
    className: "st6",
    width: 0.3,
    height: 11.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M22.4,16.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.7,1.4-1.8,2.2-3.3,2.5c-0.2,0-0.4,0-0.6,0c-2.9,0-5.8,0-8.7,0 c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.1c0.4,0.4,0.9,0.9,1.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.1-0.5-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.6-0.6-1.2-1.2-1.9-1.9c-0.3-0.3-0.3-0.5,0-0.8c0.7-0.7,1.5-1.5,2.2-2.2 c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.4-0.8,0.8-1.3,1.3 c0,0-0.1,0.1-0.1,0.1c0,0,0.1,0,0.1,0c2.9,0,5.9,0,8.8,0c1.6,0,2.8-1,3.2-2.6c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6,0-1.1,0-1.7 c0-0.3,0.1-0.5,0.3-0.5c0.2-0.1,0.4,0,0.6,0.3C22.4,14.7,22.4,15.6,22.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M22.4,10.5c0,0.1-0.1,0.2-0.2,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0-0.4-0.1-0.5-0.3 c-0.1-0.2-0.1-0.4,0.1-0.6c0.4-0.4,0.9-0.9,1.3-1.3c0,0,0.1-0.1,0.1-0.1c0,0-0.1,0-0.1,0c-2.9,0-5.8,0-8.7,0c-1.6,0-2.9,1-3.2,2.6 c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.6,0,1.2,0,1.7c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.6,0-1.3,0-1.9c0-1,0.4-1.9,1-2.6 c0.7-0.8,1.7-1.3,2.8-1.4c0.2,0,0.3,0,0.5,0c2.9,0,5.8,0,8.7,0c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.4-0.9-0.9-1.3-1.3 c-0.3-0.3-0.3-0.7,0.1-0.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.7,0.7,1.4,1.4,2.2,2.2c0.1,0.1,0.1,0.2,0.2,0.3 C22.4,10.3,22.4,10.4,22.4,10.5z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 19.8,
    y1: 10.2,
    x2: 10.2,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M10.2,10.2c9.5,9.5,9.5,9.5,9.5,9.5"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "20.2,15.3 11.9,10.1 11.5,19.9  "
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "18.2,15.3 10.9,10.7 10.6,19.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 9.5,
    className: "st9",
    width: 0.3,
    height: 11.1
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 9.5,
    className: "st10",
    width: 0.3,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 9.5,
    className: "st10",
    width: 0.3,
    height: 11.1
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "11.8,14.7 19.1,19.3 19.4,10.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 9.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 21.4583 30)",
    className: "st9",
    width: 0.3,
    height: 11.1
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M22.4,16.4c-0.1,0.4-0.2,0.8-0.3,1.2c-0.7,1.4-1.8,2.2-3.3,2.5c-0.2,0-0.4,0-0.6,0c-2.9,0-5.8,0-8.7,0 c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.1,0.1,0.1c0.4,0.4,0.9,0.9,1.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.1-0.5-0.1c-0.1-0.1-0.3-0.3-0.4-0.4c-0.6-0.6-1.2-1.2-1.9-1.9c-0.3-0.3-0.3-0.5,0-0.8c0.7-0.7,1.5-1.5,2.2-2.2 c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.1-0.1,0.1c-0.4,0.4-0.8,0.8-1.3,1.3 c0,0-0.1,0.1-0.1,0.1c0,0,0.1,0,0.1,0c2.9,0,5.9,0,8.8,0c1.6,0,2.8-1,3.2-2.6c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6,0-1.1,0-1.7 c0-0.3,0.1-0.5,0.3-0.5c0.2-0.1,0.4,0,0.6,0.3C22.4,14.7,22.4,15.6,22.4,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M22.4,10.5c0,0.1-0.1,0.2-0.2,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.1-0.4,0.1-0.6c0.4-0.4,0.9-0.9,1.3-1.3c0,0,0.1-0.1,0.1-0.1c0,0-0.1,0-0.1,0 c-2.9,0-5.8,0-8.7,0c-1.6,0-2.9,1-3.2,2.6c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.6,0,1.2,0,1.7c0,0.3-0.2,0.5-0.5,0.5 c-0.3,0-0.5-0.2-0.5-0.5c0-0.6,0-1.3,0-1.9c0-1,0.4-1.9,1-2.6c0.7-0.8,1.7-1.3,2.8-1.4c0.2,0,0.3,0,0.5,0c2.9,0,5.8,0,8.7,0 c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.1-0.1-0.1c-0.4-0.4-0.9-0.9-1.3-1.3c-0.3-0.3-0.3-0.7,0.1-0.9c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0.1,0.3,0.2c0.7,0.7,1.4,1.4,2.2,2.2c0.1,0.1,0.1,0.2,0.2,0.3C22.4,10.3,22.4,10.4,22.4,10.5z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 15,
    cy: 15,
    r: 13.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 19.8,
    y1: 10.2,
    x2: 10.2,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.2,10.2c9.5,9.5,9.5,9.5,9.5,9.5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiterepeat);
export default __webpack_public_path__ + "static/media/whiterepeat.365074d7256afad4818d77ff38b3f608.svg";
export { ForwardRef as ReactComponent };